import { Injectable } from '@angular/core';
import { PrintLabelBackgroundViewModel } from '../../print-label-background-view-model';

@Injectable()
export class BaseInventoryLabelStackBackgroundViewModel extends PrintLabelBackgroundViewModel {}
